import { render, staticRenderFns } from "./FAB.vue?vue&type=template&id=f9cfe6e4&scoped=true"
import script from "./FAB.vue?vue&type=script&lang=js"
export * from "./FAB.vue?vue&type=script&lang=js"
import style0 from "./FAB.vue?vue&type=style&index=0&id=f9cfe6e4&prod&lang=css"
import style1 from "./FAB.vue?vue&type=style&index=1&id=f9cfe6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cfe6e4",
  null
  
)

export default component.exports